import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseDate'
})
export class ParseDatePipe implements PipeTransform {

  transform(value: any): Date | null {
    if (!value) {
      return null;
    }

    // Si ya es una instancia de Date, devolverla tal como está
    if (value instanceof Date) {
      return value;
    }

    // Si es un string, intentar parsearlo
    if (typeof value === 'string') {
      // Verificar si está en formato dd/MM/yyyy
      const ddmmyyyyPattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
      const match = value.match(ddmmyyyyPattern);
      
      if (match) {
        const [, day, month, year] = match;
        // Crear fecha: los meses en JavaScript son 0-indexados
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        
        // Verificar que la fecha es válida
        if (!isNaN(date.getTime())) {
          return date;
        }
      }
      
      // Intentar parsear como fecha ISO o formato estándar
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }

    // Si es un número (timestamp), convertirlo
    if (typeof value === 'number') {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    // Si no se puede parsear, devolver null
    return null;
  }
}
